import React from 'react';

class Blank extends React.Component {
  render() {
    return <div className="text-center p-5"></div>;
  }
}

export default Blank;
